import CanvasInputListenerModeEnum from "../enums/CanvasInputListenerModeEnum";
import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import GeometryMoveEditCmd from "./GeometryMoveEditCmd";

/**
 * Constrains movement to the plane defined by the edit handle's `plane` field.
 * Falls back to a camera-facing plane if no plane is provided.
 */
export default class GeometryPlanarMoveCmd extends GeometryMoveEditCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.GeometryPlanarMove;
        this.commandNameResourceKey = 'command.geometryPlanarMove.title';
        this.initialPrompResourceKey = 'command.geometryPlanarMove.prompt';
    }

    protected override setupRaycastTarget(): void {
        if (this.editHandleData.plane) {
            this.canvasInputListener.setTargetPlane(this.editHandleData.plane);
        } else {
            this.canvasInputListener.setTargetPlaneFromCamera(this.editHandleData.position);
        }
        this.canvasInputListener.setRaycastMode(CanvasInputListenerModeEnum.RAYCAST_PLANE);
    }
}
